<!-- <div class="wrapper"> -->
<mat-form-field class="form-field mat-field-sm" style="padding: 0px !important;" [style.height]="rowHeight">
    <input type="number" matInput [(ngModel)]="value" #input step=".01" style="width: 100%" [style.width.px]="width" [style.lineHeight]='lineHeight' />
</mat-form-field>
<!-- </div> -->